export const impactMetrics = [
  { value: '40%', label: 'Reduction in Time-to-Production' },
  { value: '99.9%', label: 'Platform Uptime' },
  { value: '3×', label: 'Faster Than Traditional Consulting' },
  { value: '$2M+', label: 'Annual Client Savings' },
];

export const caseStudies = [
  {
    industry: 'Financial Services',
    challenge: 'Legacy monolith blocking innovation and slowing deployments across 12 teams.',
    solution: 'Cloud-native microservices architecture with automated CI/CD pipelines.',
    result: '60% reduction in deployment time',
  },
  {
    industry: 'Healthcare',
    challenge: 'Manual document review consuming 200+ analyst hours per week.',
    solution: 'AI-powered document processing pipeline with human-in-the-loop validation.',
    result: '85% reduction in manual review hours',
  },
  {
    industry: 'Logistics',
    challenge: 'Batch-only data processing causing 24-hour decision lag across operations.',
    solution: 'Real-time data platform with Kafka streaming and embedded analytics.',
    result: '3× improvement in decision velocity',
  },
];
